import { hasCapability, type User } from "../base";

export const quoteTab = {
  read: (user: User) => hasCapability(user, "quoteTab.read"),
};
